import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';
import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import './dx-styles.scss';
import LoadPanel from 'devextreme-react/load-panel';
import { NavigationProvider } from './contexts/navigation';
import { AuthProvider, useAuth } from './contexts/auth';
import { useScreenSizeClass } from './utils/media-query';
import Content from './Content';
import UnauthenticatedContent from './UnauthenticatedContent';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
   const { user, loading } = useAuth();
  // const Url ='https://noptest.boxonlogistics.com/';
  // const BasePath = 'https://resource.smarteweb.com/VideoTutorial/resources';
  if (loading) {
    return <LoadPanel visible={true} />;
  }

  if (user) {
    return <Content />;
  }

  return <UnauthenticatedContent />;
}

 export default function Root() {
  //const Root  =()=> {
  const screenSizeClass = useScreenSizeClass();

  return (
    <Router>
      <AuthProvider>
        <NavigationProvider>
          {/* <div className={`app ${screenSizeClass} main-layout`}> */}
          <div className={`app ${screenSizeClass} main-layout`}>
            <App />
          </div>
        </NavigationProvider>
      </AuthProvider>
    </Router>
  );
}


